import React, { useEffect, useState } from 'react';
import { BaseConfig } from '../../BaseConfig';
import { UIProperties } from '../../UIProperties';
import GameManager from '../../../cvp-webgames-core/GameManager';
var setInt: any = null;
var isMounted = false;
const MonitorOverlay = (props: MonitorOverlayConfig) => {
	const [vitals, setVitals] = useState(null);
	useEffect(() => {
		// if(isMounted) {
			isMounted = false;
			if(!setInt) {
				const sv = setVitals;
				setInt = setInterval(() => {
					sv((window as any)['vitals']);
				}, 50);
			}
		// }

		return () => {
			isMounted = true;
			if(setInt) {
				clearInterval(setInt);
				setInt = null;
			}
		}
	}, [])
	return vitals ? (
		<div className="modal-disable-select" style={{
			position: 'absolute',
			left: '0',
			top: '0',
			width: '100%',
			height: '100%',
			pointerEvents: 'none',
			zIndex: 1100
		}}>
			<div  style={{
				position: 'absolute',
				left: '0',
				top: '0',
				width: '100%',
				height: '100%',
				pointerEvents: 'none'
			}}>
				<div style={{
					position: 'absolute',
					left: '50%',
					top: '50%',
					transform: 'translate(-50%, -50%)',
					width: '940px',
					height: '540px',
				}}>
					<div style={{
						position: 'relative',
						top: '0',
						left: '0',
						width: '100%',
						height: '100px'
					}}>
						<div style={{
							position: 'absolute',
							top: '0',
							left: '0',
							width: '50%',
							height: '100px'
						}}>
							<div style={{
								width: '100%',
								height: '100%',
								borderBottom: '2px white solid',
								borderRight: '2px white solid'
							}} tabIndex={0} aria-label={'Blood Pressure. ' + Math.round(vitals.bloodPressureNumerator) + ' over ' + Math.round(vitals.bloodPressureDenominator)}>
								<p style={{
									margin: '0px',
									fontSize: (() => {
										if(vitals.bloodPressureNumerator > vitals.bloodPressureMinNumerator &&
											vitals.bloodPressureDenominator > vitals.bloodPressureMinDenominator) {
											return '35pt';
										}
	
										return '20pt'
									})(),
									textAlign: 'center',
									width: '100%',
									color: 'red',
									position: 'absolute',
									top: '50%',
									transform: 'translate(0, -50%)'
								}} className="title-font">{(() => {
									if(vitals.bloodPressureNumerator > vitals.bloodPressureMinNumerator &&
										vitals.bloodPressureDenominator > vitals.bloodPressureMinDenominator) {
										return Math.round(vitals.bloodPressureNumerator) + ' / ' + Math.round(vitals.bloodPressureDenominator);
									}

									return 'No Signal'
								})()}</p>

								<p style={{
									margin: '0px',
									fontSize: '15pt',
									textAlign: 'center',
									position: 'absolute',
									bottom: '4px',
									right: '9px',
									color: 'white'
								}} className="title-font">BP</p>
							</div>
						</div>
						<div style={{
							position: 'absolute',
							top: '0',
							right: '0',
							width: '50%',
							height: '100px'
						}}>
							<div style={{
								width: '100%',
								height: '100%',
								borderBottom: '2px white solid'
							}} tabIndex={0} aria-label={'Respiration Rate. ' + (Math.round(vitals.respirationRate))}>
								<p style={{
									margin: '0px',
									fontSize: '35pt',
									textAlign: 'center',
									width: '100%',
									color: 'yellow',
									position: 'absolute',
									top: '50%',
									transform: 'translate(0, -50%)',
								}} className="title-font">{vitals.respirationRate}</p>

								<p style={{
									margin: '0px',
									fontSize: '15pt',
									textAlign: 'center',
									position: 'absolute',
									bottom: '4px',
									right: '9px',
									color: 'white'
								}} className="title-font">RR</p>
							</div>
						</div>
					</div>
					
					<main>
						<div className="graph" style={{
							borderBottom: '2px white solid',
							position: 'relative'
						}}>
							<div className="graph-label" style={{
								position: 'absolute',
								top: '5px',
								right: '0',
								height: '100px',
								width: '149px'
							}} tabIndex={0} aria-label={'Heart Rate. ' + (Math.round(vitals.heartRate) > 0 ? Math.round(vitals.heartRate) + ' Beats Per Minute' : 'No Signal')}>
								<label style={{
									position: 'absolute',
									bottom: '2px',
									right: '2px'
								}}>HR</label> 
								<p style={{
									margin: '0px',
									fontSize: Math.round(vitals.heartRate) > 0 ? '35pt' : '20pt',
									textAlign: 'center',
									width: '150px',
									color: props.hrColor,
									position: 'absolute',
									top: '50%',
									transform: 'translate(0, -50%)',
									right: 0
								}} className="title-font">{ Math.round(vitals.heartRate) > 0 ? Math.round(vitals.heartRate) : 'No Signal'}</p>
							</div>
						</div>
						<div className="graph"  style={{
							borderBottom: '2px white solid',
							position: 'relative'
						}}>
							<div className="graph-label" style={{
								position: 'absolute',
								top: '105px',
								right: '0',
								height: '100px',
								width: '149px'
							}}  tabIndex={0} aria-label={'S A O 2. ' + (Math.round(vitals.sa02Value) > 0 ? Math.round(vitals.sa02Value) + '%' : 'No Signal')}>
								<label style={{
									position: 'absolute',
									bottom: '2px',
									right: '2px'
								}}>Sa02</label> 
								<p style={{
									margin: '0px',
									fontSize: (() => {
									var percentage = Math.round(vitals.sa02Value);
									return percentage > 0 ? '35pt' : '20pt';
									})(),
									textAlign: 'center',
									width: '150px',
									color: props.sa02Color,
									position: 'absolute',
									top: '50%',
									transform: 'translate(0, -50%)',
									right: 0
								}} className="title-font">{(() => {
									var percentage = Math.round(vitals.sa02Value);
									return percentage > 0 ? percentage : 'No Signal';
								})()} <span style={{
									fontSize: '10pt',
									position: 'absolute',
									right: '6px',
									top: '20px'
								}}>{(() => {
									var percentage = Math.round(vitals.sa02Value);
									return percentage > 0 ? '%' : '';
								})()}</span></p>
							</div>
						</div>
						<div style={{
							borderBottom: '2px white solid',
							position: 'relative'
						}} className="graph">
							<div className="graph-label" style={{
								position: 'absolute',
								top: '205px',
								right: '0',
								height: '100px',
								width: '149px'
							}} tabIndex={0} aria-label={'E T C O 2. ' + (vitals.showETC02 ? vitals.etc02Val : 'not connected')}>
								<label style={{
									position: 'absolute',
									bottom: '2px',
									right: '2px'
								}}>
									ETC02
								</label> 
								<p style={{
									margin: '0px',
									fontSize: (() => {
										if(vitals.hasEtc02Flatline && vitals.etc02Val !== '--') {
											return '20pt';
										}
										return '35pt';
									})(),
									textAlign: 'center',
									width: '150px',
									color: props.etc02Color,
									position: 'absolute',
									top: '50%',
									transform: 'translate(0, -50%)',
									right: 0
								}} className="title-font">{(() => {
									if(vitals.hasEtc02Flatline) {
										return vitals.etc02Val !== '--' ? '0' : '--';
									}
									return vitals.showETC02 ? vitals.etc02Val : '--';
								})()}</p>
							</div>
						</div>
					</main>
				</div>
			</div>
		</div>
	) : (<div className='monitor-ui' style={{
		position: 'absolute',
		left: '0',
		top: '0',
		width: '100%',
		height: '100%',
		pointerEvents: 'none'
	}}></div>);

};

export interface MonitorOverlayConfig extends BaseConfig{
	hrColor: string;
	sa02Color: string;
	etc02Color: string;
}

export default MonitorOverlay;